export const onlyDesktop = { base: "none", md: "inherit" }
export const onlyMobile = { base: "inherit", md: "none" }
